import { CellProps } from 'react-table';
import CustomIconButton from '../../../../component/custom-icon-button/CustomIconButton';


const ActionsCell = ({ row, tableOptions }: CellProps<any>) => {
	const { handleDelete, setSelectedRow, onViewSplitItems } = tableOptions;
	const rowData = row.original;

	// Show icon if quantity > 1 (regardless of merge status)
	const quantity = rowData?.attributes?.svcQuantity || rowData?.totalQuantity || 1;
	const shouldShowIcon = quantity > 1;

	// Debug logging
	console.log('ActionsCell - rowData:', {
		quantity,
		shouldShowIcon,
		hasOnViewSplitItems: !!onViewSplitItems,
		isMergedRow: rowData?.isMergedRow,
		splitGroupId: rowData?.splitGroupId,
		splitItems: rowData?.splitItems?.length,
	});

	return (
		<div className="d-flex justify-content-center gap-1">
			{shouldShowIcon && onViewSplitItems && (
				<CustomIconButton
					variant="edit"
					onClick={() => {
						onViewSplitItems(rowData);
					}}
					title="Xem chi tiết nhóm"
				>
					<i className="bi bi-list-ul text-primary"></i>
				</CustomIconButton>
			)}
			<CustomIconButton
				variant="delete"
				onClick={() => {
					handleDelete?.(row.index);
					setSelectedRow?.(row.index);
				}}
			>
				<i className="bi bi-trash3-fill text-danger"></i>
			</CustomIconButton>
		</div>
	);
};

export default ActionsCell;
